import Vue from 'vue'

// 设置拖动默认起始位置
const MOVE_START_X = 20
// 拖动最大宽度
const MAX_DRAG_WIDTH = 80
// 拖动高度宽度
const DRAG_HEIGHT = 300

function vueTouch (el, binding, type) {
  this.obj = el
  this.binding = binding
  this.touchType = type
  this.dynamicElement = null
  this.vueTouches = { x: 0, y: 0 }
  this.vueCallBack = typeof (binding.value) === 'object' ? binding.value.fn : binding.value
  this.obj.addEventListener('touchstart', this.start.bind(this))
  this.obj.addEventListener('touchmove', this.move.bind(this))
  this.obj.addEventListener('touchend', this.end.bind(this))
}
vueTouch.prototype = {
  start (e) { // 触摸开发
    this.vueTouches = {
      x: e.touches[0].pageX,
      y: e.touches[0].pageY
    }
  },
  move (e) { // 触摸中
    const touch = e.touches[0]
    // 计算X和Y方向上的移动距离
    const deltaX = touch.pageX - this.vueTouches.x
    const deltaY = touch.pageY - this.vueTouches.y
    // 计算移动距离
    const moveX = touch.clientX
    // 计算拖动宽度
    const draggedWidth = Math.max(0, moveX - this.vueTouches.x)
    // 判断是否是水平方向上的移动，并且触摸点在屏幕左侧
    if (Math.abs(deltaX) > Math.abs(deltaY) && this.vueTouches.x <= MOVE_START_X) {
      if (deltaX > 0) {
        // 阻止默认行为，防止页面滚动
        e.preventDefault()
        // 如果没有创建拖动DOM元素，则创建
        if (!this.dynamicElement) {
          this.dynamicElement = document.createElement('div')
          this.dynamicElement.classList.add('drag-back-bar')
          document.body.appendChild(this.dynamicElement)
        }
        // 如果拖动宽度小于最大宽度，则更新DOM元素的宽度
        if (draggedWidth <= MAX_DRAG_WIDTH) {
          this.dynamicElement.style.width = `${draggedWidth}px`
          this.dynamicElement.style.height = `${DRAG_HEIGHT}px`
          this.dynamicElement.style.zIndex = '1'
          this.dynamicElement.style.position = 'fixed'
          this.dynamicElement.style.left = `-${draggedWidth / 1.5}px`
          this.dynamicElement.style.top = `50%`
          this.dynamicElement.style.bottom = '50%'
          this.dynamicElement.style.transform = 'translateY(-50%)'
          this.dynamicElement.style.borderRadius = '0 50% 50% 0'
          this.dynamicElement.style.lineHeight = '300px'
          this.dynamicElement.style.overflow = 'hidden'
          this.dynamicElement.style.backgroundColor = 'rgba(0, 0, 0, 0.6)'
        }
      }
    }
  },
  end (e) { // 触摸结束
    var deltaX = e.changedTouches[0].pageX - this.vueTouches.x
    var deltaY = e.changedTouches[0].pageY - this.vueTouches.y
    if (Math.abs(deltaX) >= MAX_DRAG_WIDTH && Math.abs(deltaX) > Math.abs(deltaY)) {
      if (deltaX >= MAX_DRAG_WIDTH && this.dynamicElement && this.dynamicElement.parentNode) {
        console.log('左滑返回')
        this.touchType === 'touchBack' && this.vueCallBack(this.touchType, e)
      }
    }
    if (this.dynamicElement && this.dynamicElement.parentNode) {
      // 移除动态创建的DOM元素
      this.dynamicElement.parentNode.removeChild(this.dynamicElement)
      this.dynamicElement = null
    }
  }
}

// 注册右滑返回指令
Vue.directive('touchBack', {
  bind: function (el, binding) {
    // eslint-disable-next-line
    new vueTouch(el, binding, 'touchBack')
  }
})
